import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import CommunicationsTabs from "../components/communications/CommunicationsTabs";

export default function CommunicationsPage() {
    return (
        <>
            <PageMeta
                title="Communications | Shoplattice Admin Dashboard"
                description="Manage Newsletters and Subscribers"
            />
            <PageBreadcrumb pageTitle="Communications" />
            <div className="space-y-6">
                <CommunicationsTabs />
            </div>
        </>
    );
}
